<div
  class="wrapper"
  gdGap="8px"
  gdRows="fit-content(30vh)"
  gdColumns="50% 50%"
  gdColumns.lt-lg="100% 50%"
  gdColumns.lt-md="auto"
  gdAreas="scrub cloudsync | snapshot rsync  | replication smart"
  gdAreas.lt-lg="scrub | snapshot | replication | cloudsync | rsync | smart"
  gdAreas.lt-md="scrub | snapshot | replication | cloudsync | rsync | smart"
>
  <div *ngFor="let card of dataCards; index as i" [gdArea]="card.name">
    <ix-conf-table fxFlex [conf]="card.tableConf"></ix-conf-table>
  </div>
</div>
